type Translations = Record<string, Record<string, string>>;

export const makeTranslator = <T extends Translations>(strings: T) => (
  stringId: keyof T,
  options?: Record<string, string>
) => {
  let string = strings[stringId]['en-US'];

  if (options) {
    Object.keys(options).forEach(key => {
      const value = options[key];
      string = string.replace(new RegExp('{' + key + '}', 'g'), value);
    });
  }

  return string;
};
